import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../navigation/Footer';
import Navbar from '../navigation/Navbar';
import * as Styled from './FourOhFourPage.styles';
import Layout from './Layout';
import { useTranslation } from 'react-i18next';

const FourOhFourPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <Navbar />
      <Layout>
        <Styled.Container>
          <h1>{t('pages.fourOhFour.title')}</h1>
          <p>{t('pages.fourOhFour.text')}</p>
          <Link to='/'>
            <Styled.Btn>{t('pages.fourOhFour.button')}</Styled.Btn>
          </Link>
        </Styled.Container>
      </Layout>
      <Footer />
    </>
  );
};

export default FourOhFourPage;
